import axiosInstance from './axiosConfig';
import { apis } from './params';

export interface ShippingAttr {
    shippingCriteriaId?: number;
    priority: number;
    active: boolean;
    date_active?: string;
    date_expiry?: string;
}

export interface CriteriaCondition {
    categoryType: 'PRODUCT' | 'CATEGORY' | 'BRAND' | 'CART' | string;
    attributeList: Array<{
        categoryType?: string;
        attributeType: string;
        attributeValue?: string;
        attributeValues?: string[];
    }>;
}

export interface ActionCondition {
    categoryType: 'SHIPPING' | string;
    attributeList: Array<{
        categoryType?: string;
        attributeType: 'FIXED' | 'PERCENTAGE' | 'SPECIAL_PRODUCT_SHIPPING_CHARGE' | 'SHIPPING_CHARGE_TYPE' | string;
        attributeValue?: string;
        attributeValues?: string[];
    }>;
}

export interface RuleCondition {
    conditionsList: Array<{
        evaluationType?: string;
        criteriaList: CriteriaCondition[];
    }>;
    actionList: {
        criteriaList: ActionCondition[];
    };
}

export interface RuleCriteria {
    priority: number;
    evaluationType: 'ANY_OF' | 'ALL_OF' | string;
    ruleList: RuleCondition[];
}

export interface ShippingRulePayload {
    shippingAttr: ShippingAttr;
    ruleCriteriaList: RuleCriteria[];
}

/**
 * Service to fetch all shipping rules & criteria.
 */
export function getShippingRulesService() {
    return axiosInstance({
        method: "Get",
        url: apis.GET_SHIPPING_RULES
    });
}

/**
 * Service to fetch shipping criteria detail by ID.
 */
export function getShippingRuleDetailService(shippingCriteriaId: number | string) {
    return axiosInstance({
        method: "Get",
        url: `${apis.GET_SHIPPING_RULE_BY_ID}?shippingCriteriaId=${shippingCriteriaId}`
    });
}

/**
 * Service to create a new shipping criteria rule.
 */
export function createShippingCriteriaService(body: ShippingRulePayload) {
    return axiosInstance({
        method: "Post",
        url: apis.CREATE_SHIPPING_RULE,
        data: body
    });
}

/**
 * Service to update an existing shipping criteria rule.
 */
export function updateShippingCriteriaService(body: ShippingRulePayload) {
    return axiosInstance({
        method: "Post",
        url: apis.UPDATE_SHIPPING_RULE,
        data: body
    });
}

/**
 * Service to fetch Category Map (Level-1 categories / category ID-to-name mapping) for shipping rules.
 */
export function getCategoryLevelOneService() {
    return axiosInstance({
        method: "Get",
        url: apis.GET_SHIPPING_CATEGORY_LEVEL_ONE
    });
}

export const getCategoryMapService = getCategoryLevelOneService;

/**
 * Service to export shipping rules report.
 */
export function exportShippingRulesService(categoryIds: string, email: string) {
    return axiosInstance({
        method: "Get",
        url: `${apis.EXPORT_SHIPPING_RULES}?category_ids=${encodeURIComponent(categoryIds)}&email=${encodeURIComponent(email)}`
    });
}

/**
 * Service to bulk upload shipping rules CSV/Excel file.
 */
export function uploadShippingRulesBulkService(formData: FormData) {
    return axiosInstance({
        method: "Post",
        url: apis.UPLOAD_SHIPPING_BULK,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}
